<template>
	<svg class="svg-chart w-full h-auto" viewBox="250 0 500 1000" xmlns="http://www.w3.org/2000/svg" xml:space="preserve">
		<g v-for="(region, identifier) in regionParts" :key="`region-${identifier}`">
			<path :id="`region-${identifier}`" :class="region.class" :d="region.d"/>
		</g>
	</svg>
</template>
<script setup lang="ts">
import {type Region} from '@/Types/Region'
import {ref, type Ref, defineProps, onMounted} from 'vue'
import regions from '@/Components/UI/Maps/Argentina/argentinaRegions.json'

interface SvgPath {
	class:string,
	name:string,
	d:string,
}

const props = defineProps<{
	total:number,
	data:Array<Region>,
}>()

const total:Ref<number> = ref(props.total)
const data:Ref<Array<Region>> = ref(props.data)

regions.forEach((svgPath:SvgPath, i:number) => {
	const base:string = 'stroke-gray-300 dark:stroke-gray-700 stroke-1'
	const region:Region|undefined = getRegionById(i + 1)
	if(region){
		const percentage:number = getPercentageByRegion(region)
		if(percentage < 10){
			svgPath.class = `${base} fill-true-aareii-50`
		} else if(percentage < 20){
			svgPath.class = `${base} fill-true-aareii-100`
		} else if(percentage < 30){
			svgPath.class = `${base} fill-true-aareii-200`
		} else if(percentage < 40){
			svgPath.class = `${base} fill-true-aareii-300`
		} else if(percentage < 50){
			svgPath.class = `${base} fill-true-aareii-400`
		} else if(percentage < 60){
			svgPath.class = `${base} fill-true-aareii-500`
		} else if(percentage < 70){
			svgPath.class = `${base} fill-true-aareii-600`
		} else if(percentage < 80){
			svgPath.class = `${base} fill-true-aareii-700`
		} else if(percentage < 90){
			svgPath.class = `${base} fill-true-aareii-800`
		} else if(percentage <= 100){
			svgPath.class = `${base} fill-true-aareii-900`
		}
	}
})

const regionParts:Ref<Array<SvgPath>> = ref(regions)

function addLabelText(bgPath:SVGPathElement, labelText:string):void{
	const bbox = bgPath.getBBox();
	const x = bbox.x + bbox.width / 2;
	const y = bbox.y + bbox.height / 2;
	const textElem = document.createElementNS(bgPath.namespaceURI, "text");
	textElem.setAttribute("x", x.toString());
	textElem.setAttribute("y", y.toString());
	textElem.setAttribute("text-anchor", "middle");
	textElem.classList.add("label-text");
	textElem.textContent = labelText;
	bgPath.after(textElem);
}

function getRegionById(id:number):Region|undefined{
	return data.value.find((r:Region) => r.id === id)
}

function getPercentageByRegion(region:Region):number{
	return Math.floor(total.value ? region.users_count / total.value * 100 : 0)
}

onMounted(():void => {
	for(let i = 0; i < regionParts.value.length; i++){
		const regionPath = document.querySelector(`#region-${i}`) as SVGPathElement;
		if(regionPath){
			const region:Region|undefined = getRegionById(i + 1)
			if(region){
				addLabelText(regionPath, region.users_count.toString())
			}
		}
	}
})
</script>
